import React, { Component } from 'react';
import { Grid, Box, IconButton } from '@material-ui/core';
import * as icons from '@material-ui/icons';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import { connect } from 'react-redux';
import {
  setBaseInfoFlg,
  setCompanyInfoFlg,
  setHierarchyKbn,
  searchCompanyHierarchyList,
  searchCompanyOfficeInfo,
  searchCompanyOfficeInfoLight,
  setCompanyInfo,
  setBlindFlg,
  setParentsLinkBlindFlg,
  setRootLinkBlindFlg,
  setAreaHierarchyFlg,
} from '../../actions/CompanyAction';
import {
  setSystemLodingFLg,
  setInitMessage,
} from '../../actions/CommonAction';
import {
  HIERARCHY_KBN,
  COMPANY_DETAIL_BLIND,
  LIGHT_FLG,
  RESULT_CODE,
  DIPS_CATEGORY,
  ITEM_NAME_EN,
  MAP_ICON_FLG,
} from '../../../common/const';
import styles from './CompanyInfoComponent.module.css';

class CompanyInfoComponent extends Component {
  async componentDidUpdate(preProps) {
    const {
      selectedCompanyInfo,
      searchCompanyOfficeInfoAct,
      searchCompanyOfficeInfoLightAct,
      setInitMessageAct,
      setCompanyInfoAct,
      setBlindFlgAct,
      setParentsLinkBlindFlgAct,
      setRootLinkBlindFlgAct,
      setAreaHierarchyFlgAct,
      userInfo,
      dispItem,
      setSystemLodingFLgAct,
    } = this.props;

    const targetOfficeCode = selectedCompanyInfo.office_code;
    setSystemLodingFLgAct(true);
    if (targetOfficeCode) {
      // 企業、事業所の選択状態が変更された場合、事業所情報詳細を取得
      if (preProps.selectedCompanyInfo.office_code !== targetOfficeCode) {
        setInitMessageAct();
        if (userInfo.light_flag === LIGHT_FLG.ON) {
          // ライト版の処理
          const ret = await searchCompanyOfficeInfoLightAct(targetOfficeCode);
          if (ret.result === RESULT_CODE.SUCCESS) {
            // ステータスが「200」の場合
            setCompanyInfoAct(ret.response);
            setBlindFlgAct(false);
            setAreaHierarchyFlgAct(false);
            // 国内親会社及び国内最上位親会社で事業情報詳細取得
            if (ret.response.display_list) {
              let parentsCode;
              let rootsCode;
              ret.response.display_list.forEach((dList) => {
                if (dList.display_column === ITEM_NAME_EN.OYA_DUNS
                  || dList.display_column === ITEM_NAME_EN.OYA_TSR) {
                  [, parentsCode] = dList.display_value;
                } else if (dList.display_column === ITEM_NAME_EN.SIJO_OYA_DUNS
                  || dList.display_column === ITEM_NAME_EN.SIJO_OYA_TSR) {
                  [, rootsCode] = dList.display_value;
                }
              });

              if (parentsCode) {
                const retParents = await searchCompanyOfficeInfoLightAct(parentsCode);
                // ステータスが「404」の場合は、国内親会社リンク非表示フラグをtrueに設定する。
                if (retParents.result === RESULT_CODE.NOT_FOUND) {
                  setParentsLinkBlindFlgAct(true);
                } else {
                  setParentsLinkBlindFlgAct(false);
                }
              } else {
                setParentsLinkBlindFlgAct(true);
              }

              if (rootsCode) {
                const retRoots = await searchCompanyOfficeInfoLightAct(rootsCode);
                // ステータスが「404」の場合は、国内親会社リンク非表示フラグをtrueに設定する。
                if (retRoots.result === RESULT_CODE.NOT_FOUND) {
                  setRootLinkBlindFlgAct(true);
                } else {
                  setRootLinkBlindFlgAct(false);
                }
              } else {
                setRootLinkBlindFlgAct(true);
              }
            }
          } else if (ret.result === RESULT_CODE.NOT_FOUND) {
            // ステータスが「404」の場合は非公開フラグをtrueに設定
            setCompanyInfoAct(dispItem);
            setBlindFlgAct(true);
            setAreaHierarchyFlgAct(true);
          } else if (dispItem) {
            // ステータスが「200」でも「404」でも無い場合は異常系として処理
            setCompanyInfoAct(dispItem);
          }
        } else {
          // 非ライト版の処理
          await searchCompanyOfficeInfoAct(targetOfficeCode);
        }
      }
    } else if (preProps.selectedCompanyInfo.office_code) {
      // 選択状態から未選択状態に変更された場合、事業所情報詳細を初期化
      setCompanyInfoAct(dispItem);
    }
    setSystemLodingFLgAct(false);
    // 更新されたらスクロール位置をトップに戻す
    document.getElementById('companyInfo').scrollTo(0, 0);
  }

  /**
   * 国内親会社DUNS、国内最上位親会社DUNSリンクをクリックした場合、出資率50%超を表示
   */
  searchCompanyOfficeList = async (kigyoCode) => {
    const {
      setSystemLodingFLgAct,
      setHierarchyKbnAct,
      searchCompanyHierarchyListAct,
    } = this.props;

    setSystemLodingFLgAct(true);
    // 検索処理を実行し、一時保存領域で保持する
    const ret = await searchCompanyHierarchyListAct(kigyoCode);
    if (ret) {
      setHierarchyKbnAct(HIERARCHY_KBN.FUND);
    }
    setSystemLodingFLgAct(false);
  };

  render() {
    const {
      baseInfoFlg,
      companyInfoFlg,
      companyInfo,
      blindFlg,
      parentsLinkBlindFlg,
      rootLinkBlindFlg,
      setBaseInfoFlgAct,
      setCompanyInfoFlgAct,
    } = this.props;

    const SPACE = ' ';
    const BREAK = '<br>';
    const displayColum = (companyData, j) => {
      const splitLabel = companyData.display_label_name.split(BREAK);
      let splitData;
      let kcd;
      let str;
      let normalFlg = false;
      if (companyData.display_column === ITEM_NAME_EN.OYA_DUNS
        || companyData.display_column === ITEM_NAME_EN.OYA_TSR
        || companyData.display_column === ITEM_NAME_EN.SIJO_OYA_DUNS
        || companyData.display_column === ITEM_NAME_EN.SIJO_OYA_TSR) {
        if (companyData.display_value) {
          splitData = companyData.display_value[0].toString().split(SPACE);
          if (splitData.length > 1) {
            splitData = companyData.display_value[0].toString().split(SPACE);
            [, kcd] = companyData.display_value;
            normalFlg = true;
          } else {
            str = companyData.display_value[0].toString();
          }
        } else {
          str = '';
        }
      }
      if (companyData.display_column === ITEM_NAME_EN.OYA_DUNS
        || companyData.display_column === ITEM_NAME_EN.OYA_TSR) {
        return (
          <li className={`${styles.row}`} key={`${companyData.display_label_name}_${j}`}>
            <Box className={`${styles.rowtitle}`}>
              {splitLabel.map((label, i) => (
                <Box key={`${label}_${i}`}>
                  {label || ''}
                  <br />
                </Box>
              ))}
            </Box>
            {
              normalFlg ? (
                <Box className={`${styles.item}`}>
                  <div
                    className={parentsLinkBlindFlg ? `${styles.dunstext}` : `${styles.dunslink}`}
                    onClick={parentsLinkBlindFlg
                      ? null
                      : this.searchCompanyOfficeList.bind(this, kcd)}
                  >
                    {splitData[0]}
                  </div>
                  {splitData[1] || ''}
                </Box>
              ) : <Box className={`${styles.item}`}><Box className={`${styles.dunstext}`}>{str}</Box></Box>
            }
          </li>
        );
      }
      if (companyData.display_column === ITEM_NAME_EN.SIJO_OYA_DUNS
        || companyData.display_column === ITEM_NAME_EN.SIJO_OYA_TSR) {
        return (
          <li className={`${styles.row}`} key={`${companyData.display_label_name}_${j}`}>
            <Box className={`${styles.rowtitle}`}>
              {splitLabel.map((label, i) => (
                <Box key={`${label}_${i}`}>
                  {label || ''}
                  <br />
                </Box>
              ))}
            </Box>
            {
              normalFlg ? (
                <Box className={`${styles.item}`}>
                  <div
                    className={rootLinkBlindFlg ? `${styles.dunstext}` : `${styles.dunslink}`}
                    onClick={rootLinkBlindFlg
                      ? null
                      : this.searchCompanyOfficeList.bind(this, kcd)}
                  >
                    {splitData[0]}
                  </div>
                  {splitData[1] || ''}
                </Box>
              ) : <Box className={`${styles.item}`}><Box className={`${styles.dunstext}`}>{str}</Box></Box>
            }
          </li>
        );
      }
      if (companyData.display_column === ITEM_NAME_EN.KGY_URL) {
        return (
          <li className={`${styles.row}`} key={`${companyData.display_label_name}_${j}`}>
            <Box className={`${styles.rowtitle}`}>
              {splitLabel.map((label, i) => (
                <Box key={`${label}_${i}`}>
                  {label || ''}
                  <br />
                </Box>
              ))}
            </Box>
            {
              companyData.display_value ? (
                <Box className={`${styles.item}`}>
                  {companyData.display_value.map((data, i) => (
                    <Box key={`${data}_${i}`}>
                      <Box
                        key={`${data}_${i}`}
                        className={`${styles.url} ${styles.itemborder}`}
                        onClick={data
                          ? () => window.open(data)
                          : null}
                      >
                        {data || ''}
                      </Box>
                    </Box>
                  ))}
                </Box>
              ) : <Box className={`${styles.item}`} />
            }
          </li>
        );
      }
      if (companyData.address_link_flg === MAP_ICON_FLG.MAP_ICON_ON) {
        return (
          <li className={`${styles.row}`} key={`${companyData.display_label_name}_${j}`}>
            <Box className={`${styles.rowtitle}`}>
              {splitLabel.map((label, i) => (
                <Box key={`${label}_${i}`}>
                  {label || ''}
                  <br />
                </Box>
              ))}
            </Box>
            {
              companyData.display_value ? (
                <Box className={`${styles.listitem}`}>
                  <Box className={`${styles.map} ${styles.listitemborder}`}>
                    <IconButton
                      className={`${styles.mapButton}`}
                      size="small"
                      color="secondary"
                      onClick={() => window.open(`https://google.co.jp/maps/search/${companyData.display_value}`, '_blank')}
                      tabIndex="-1"
                    >
                      <icons.Place />
                    </IconButton>
                    {companyData.display_value.map((data, i) => (
                      <span key={`${data}_${i}`}>
                        {data}
                      </span>
                    ))}
                  </Box>
                </Box>
              ) : <Box className={`${styles.item}`} />
            }
          </li>
        );
      }
      return (
        <li className={`${styles.row}`} key={`${companyData.display_label_name}_${j}`}>
          <Box className={`${styles.rowtitle}`}>
            {splitLabel.map((label, i) => (
              <Box key={`${label}_${i}`}>
                {label || ''}
                <br />
              </Box>
            ))}
          </Box>
          {
            companyData.display_value ? (
              <Box className={`${styles.listitem}`}>
                {companyData.display_value.map((data, i) => (
                  <Box key={`${data}_${i}`} className={`${styles.listitemborder}`}>
                    {data}
                  </Box>
                ))}
              </Box>
            ) : <Box className={`${styles.item}`} />
          }
        </li>
      );
    };

    return (
      <Box className={`${styles.companyinfo}`}>
        <Box
          tabIndex="-1"
          id="companyInfo"
          className={blindFlg
            ? `${styles.scroll} scrollbar ${styles.blind}`
            : `${styles.scroll} scrollbar`}
        >
          <ul
            className={blindFlg
              ? `${styles.companyinfofield} ${styles.blind}`
              : `${styles.companyinfofield}`}
            data-message={COMPANY_DETAIL_BLIND.MESSAGE}
          >
            <li className={`${styles.header}`}>
              <Box className={`${styles.headertitle}`}>拠点情報</Box>
              <div
                className={`${styles.openclose}`}
                onClick={setBaseInfoFlgAct.bind(this, !baseInfoFlg)}
              >
                {
                  baseInfoFlg ? (
                    <Grid container>
                      <Box className={`${styles.paddingtop}`}>
                        とじる
                      </Box>
                      <Box>
                        <ArrowDropUpIcon />
                      </Box>
                    </Grid>
                  ) : (
                    <Grid container>
                      <Box className={`${styles.paddingtop}`}>
                        ひらく
                      </Box>
                      <Box>
                        <ArrowDropDownIcon />
                      </Box>
                    </Grid>
                  )
                }
              </div>
            </li>
            {baseInfoFlg && (
              <Box>
                {companyInfo.display_list
                  && companyInfo.display_list.map((cInfo) => (
                    Number(cInfo.display_category) === DIPS_CATEGORY.BASE_INFO && (
                      displayColum(cInfo)
                    )
                  ))}
              </Box>
            )}
            <li className={`${styles.separate}`} />
            <li className={`${styles.header}`}>
              <Box className={`${styles.headertitle}`}>企業情報</Box>
              <div
                className={`${styles.openclose}`}
                onClick={setCompanyInfoFlgAct.bind(this, !companyInfoFlg)}
              >
                {
                  companyInfoFlg ? (
                    <Grid container>
                      <Box className={`${styles.paddingtop}`}>
                        とじる
                      </Box>
                      <Box>
                        <ArrowDropUpIcon />
                      </Box>
                    </Grid>
                  ) : (
                    <Grid container>
                      <Box className={`${styles.paddingtop}`}>
                        ひらく
                      </Box>
                      <Box>
                        <ArrowDropDownIcon />
                      </Box>
                    </Grid>
                  )
                }
              </div>
            </li>
            {companyInfoFlg && (
              <Box>
                {companyInfo.display_list
                  && companyInfo.display_list.map((cInfo, i) => (
                    Number(cInfo.display_category) === DIPS_CATEGORY.COMPANY_INFO && (
                      displayColum(cInfo, i)
                    )
                  ))}
              </Box>
            )}
          </ul>
        </Box>
      </Box>
    );
  }
}

export default connect(
  (state) => ({
    // 拠点情報の表示フラグ
    baseInfoFlg: state.company.baseInfoFlg,
    // 企業情報の表示フラグ
    companyInfoFlg: state.company.companyInfoFlg,
    // 企業情報（拠点情報、企業情報）
    companyInfo: state.company.companyInfo,
    // 選択中企業情報
    selectedCompanyInfo: state.company.selectedCompanyInfo,
    // 非公開フラグ
    blindFlg: state.company.blindFlg,
    // 親会社リンクフラグ
    parentsLinkBlindFlg: state.company.parentsLinkBlindFlg,
    // 最上位親会社リンクフラグ
    rootLinkBlindFlg: state.company.rootLinkBlindFlg,
    // ユーザー情報
    userInfo: state.common.userInfo,
    // 表示項目情報
    dispItem: state.common.dispItem,
  }),
  (dispatch) => ({
    setBaseInfoFlgAct: (bool) => dispatch(setBaseInfoFlg(bool)),
    setCompanyInfoFlgAct: (obj) => dispatch(setCompanyInfoFlg(obj)),
    setHierarchyKbnAct: (str) => dispatch(setHierarchyKbn(str)),
    searchCompanyHierarchyListAct: (obj) => dispatch(searchCompanyHierarchyList(obj)),
    searchCompanyOfficeInfoAct: (str) => dispatch(searchCompanyOfficeInfo(str)),
    searchCompanyOfficeInfoLightAct: (str) => dispatch(searchCompanyOfficeInfoLight(str)),
    setSystemLodingFLgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
    setInitMessageAct: () => dispatch(setInitMessage()),
    setCompanyInfoAct: (object) => dispatch(setCompanyInfo(object)),
    setBlindFlgAct: (bool) => dispatch(setBlindFlg(bool)),
    setParentsLinkBlindFlgAct: (bool) => dispatch(setParentsLinkBlindFlg(bool)),
    setRootLinkBlindFlgAct: (bool) => dispatch(setRootLinkBlindFlg(bool)),
    setAreaHierarchyFlgAct: (bool) => dispatch(setAreaHierarchyFlg(bool)),
  }),

)(CompanyInfoComponent);
